import React from 'react';
import PropTypes from 'prop-types';
import EventModal from 'shared/components/EventModal';
import Container from 'shared/components/Container';
import EditVolunteerContent from './EditVolunteerContent';

const EditVolunteerModal = props => {
  const { onCancel, visible, organizationId } = props;

  return (
    <EventModal
      visible={visible}
      onCancel={onCancel}
      renderHeader={() => (
        <span>
          Edit User
        </span>
)}
    >
      <Container>
        <h1> Edit User </h1>

      </Container>
      <EditVolunteerContent 
        organizationId={organizationId}
        closeModal={onCancel}
      />
    </EventModal>
  );
};

EditVolunteerModal.propTypes = {
  visible: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
  organizationId: PropTypes.string
};

EditVolunteerModal.defaultProps = {
  organizationId: null
}

export default EditVolunteerModal;